import { render, staticRenderFns } from "./ConferenciaResumo.vue?vue&type=template&id=63b21593"
import script from "./ConferenciaResumo.vue?vue&type=script&lang=js"
export * from "./ConferenciaResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports